(() => {
  const locale = String(window.Shopify?.locale || document.documentElement.lang || 'de').toLowerCase().split('-')[0];

  const translations = {
    de: {
      '10 % WILLKOMMENSRABATT': '10% WILLKOMMENSRABATT',
      'Melde dich für Lala-Post an. Nach der E-Mail-Bestätigung senden wir dir deinen persönlichen Einmal-Code.': 'Bestätige deine E-Mail und erhalte deinen persönlichen 10%-Einmal-Code.'
    },
    en: {
      '10 % WILLKOMMENSRABATT': '10% WELCOME DISCOUNT',
      'Melde dich für Lala-Post an. Nach der E-Mail-Bestätigung senden wir dir deinen persönlichen Einmal-Code.': 'Confirm your email to get your personal one-time 10% code.',
      'E-Mail-Adresse': 'Email address',
      '10 % RABATT SICHERN': 'CLAIM 10% DISCOUNT',
      'Nein, danke': 'No, thanks',
      'Mit der Anmeldung stimmst du Lala-E-Mails zu. Kein Spam – jederzeit abmeldbar.': 'By signing up, you agree to receive Lala emails. No spam — unsubscribe anytime.'
    },
    fr: {
      '10 % WILLKOMMENSRABATT': '10 % DE RÉDUCTION DE BIENVENUE',
      'Melde dich für Lala-Post an. Nach der E-Mail-Bestätigung senden wir dir deinen persönlichen Einmal-Code.': 'Confirme ton e-mail pour recevoir ton code personnel de 10 % à usage unique.',
      'E-Mail-Adresse': 'Adresse e-mail',
      '10 % RABATT SICHERN': 'OBTENIR 10 % DE RÉDUCTION',
      'Nein, danke': 'Non, merci',
      'Mit der Anmeldung stimmst du Lala-E-Mails zu. Kein Spam – jederzeit abmeldbar.': 'En t’inscrivant, tu acceptes de recevoir les e-mails Lala. Pas de spam — désinscription à tout moment.'
    },
    it: {
      '10 % WILLKOMMENSRABATT': '10% DI SCONTO DI BENVENUTO',
      'Melde dich für Lala-Post an. Nach der E-Mail-Bestätigung senden wir dir deinen persönlichen Einmal-Code.': 'Conferma la tua e-mail per ricevere il tuo codice personale monouso del 10%.',
      'E-Mail-Adresse': 'Indirizzo e-mail',
      '10 % RABATT SICHERN': 'OTTIENI IL 10% DI SCONTO',
      'Nein, danke': 'No, grazie',
      'Mit der Anmeldung stimmst du Lala-E-Mails zu. Kein Spam – jederzeit abmeldbar.': 'Iscrivendoti accetti di ricevere le e-mail Lala. Niente spam — puoi annullare l’iscrizione in qualsiasi momento.'
    }
  }[locale];
  if (!translations) return;

  const offerLabels = {
    de: 'WILLKOMMENSRABATT',
    en: 'WELCOME DISCOUNT',
    fr: 'DE RÉDUCTION DE BIENVENUE',
    it: 'DI SCONTO DI BENVENUTO'
  };

  const decorateOffer = (root) => {
    root.querySelectorAll?.('[class*="ecomsend__Modal__TitleText"]').forEach((title) => {
      if (title.dataset.lalaOfferReady === 'true' || !title.textContent.includes('10')) return;
      title.replaceChildren();
      const amount = document.createElement('span');
      amount.className = 'lala-ecomsend-offer__amount';
      amount.textContent = '10%';
      const label = document.createElement('span');
      label.className = 'lala-ecomsend-offer__label';
      label.textContent = offerLabels[locale];
      title.append(amount, label);
      title.dataset.lalaOfferReady = 'true';
    });
  };

  const translate = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const source = node.nodeValue.trim();
      if (translations[source]) node.nodeValue = node.nodeValue.replace(source, translations[source]);
    }
    root.querySelectorAll?.('input[placeholder], [aria-label]').forEach((element) => {
      for (const attribute of ['placeholder', 'aria-label']) {
        const source = element.getAttribute(attribute)?.trim();
        if (source && translations[source]) element.setAttribute(attribute, translations[source]);
      }
    });
    root.querySelectorAll?.('[class*="ecomsend__Modal__CloseText"]').forEach((closeText) => {
      closeText.style.setProperty('background', 'transparent', 'important');
      closeText.style.setProperty('-webkit-text-fill-color', 'rgba(29, 29, 29, .62)', 'important');
    });
    decorateOffer(root);
  };

  translate(document.body);
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) translate(node);
        else if (node.nodeType === Node.TEXT_NODE && translations[node.nodeValue.trim()]) {
          const source = node.nodeValue.trim();
          node.nodeValue = node.nodeValue.replace(source, translations[source]);
        }
      });
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
